/* eslint-disable */
import { checkForAccess, subscriptionTypes } from 'rp-auth';

export default class {
    constructor($scope, $attrs) {
        'ngInject'; // Dependency injection annotation for minification safety

        const userSubscriptionLevel = $attrs.userSubscriptionLevel;
        const sections = ['analysis', 'my-ratings', 'past-winners'];
        const { INSIGHTS, ULTIMATE, ESSENTIAL } = subscriptionTypes;
        const isAuthorized = userSubscriptionLevel === INSIGHTS || userSubscriptionLevel === ULTIMATE || userSubscriptionLevel === ESSENTIAL; //Only users that are Insights/Ultimate should be able to access the tabs
        const urlChunks = window.location.href.split('/'); //Get all chunks from the url
        const section = urlChunks[8]; //Get the desired section, since is the 8th chunk of the url
        
        if (sections.includes(section) && !isAuthorized) {
            window.location.href = `${window.location.origin}/racecards?authme`;
        }

        const pageName = 'result';
        const step = 'Subscriptions';

        $scope.handleClick = function ($event, link, title) {
            $event.preventDefault();
            let section = title.toLowerCase().replaceAll(' ', '_');
            let text = 'Subscribe to Racing Post+ to access our in-depth results analysis on every British and Irish race, add your own notes and view past winners.'
            
            if (section !== pageName) {
                const hasAccess = checkForAccess(step, true, false,
                { text, r: `${window.location}`, service: 'both' },
                true,
                userSubscriptionLevel,
                'results',
                section);
                if (hasAccess) {
                    window.location.href = link;
                } 
            } else {
                window.location.href = link;
            }
        };
    }
}




// WEBPACK FOOTER //
// ./src/js/controllers/navBarCtrl.js